import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TechnoIcon from "../components/TechnoIcon.js";

const ListeDeProjets = () => {
  const { t } = useTranslation();
  const [filtreActif, setFiltreActif] = useState("tous");
  const history = useHistory();


  const projetsData = t("projects", { returnObjects: true });

  const filtrerProjets = () => {
    if (filtreActif === "tous") {
      return projetsData;
    }
    return projetsData.filter((projet) => {
      const coursLower = projet.cours.toLowerCase();
      return (
        coursLower === filtreActif.toLowerCase() ||
        coursLower === "final project" ||
        coursLower === "projet final"
      );
    });
  };

  const projetsAffichés = filtrerProjets();

  return (
    <div>
      <div className="container mb-5">
        <div className="row">
          <h2 className="titre text-md-start text-center ps-2">{t("mes.projets")}</h2>

          <div className="filtres-container">
            <button
              className={`filtre-buttons ${filtreActif === "tous" ? "actif" : ""}`}
              onClick={() => setFiltreActif("tous")}
            >
              {t("all")}
            </button>
            <button
              className={`filtre-buttons ${filtreActif === "intégration" ? "actif" : ""}`}
              onClick={() => setFiltreActif("intégration")}
            >
              {t("integration")}
            </button>
            <button
              className={`filtre-buttons ${filtreActif === "programmation" ? "actif" : ""}`}
              onClick={() => setFiltreActif("programmation")}
            >
              {t("Programmation")}
            </button>
            <button
              className={`filtre-buttons ${filtreActif === "design" ? "actif" : ""}`}
              onClick={() => setFiltreActif("design")}
            >
              {t("Design")}
            </button>
          </div>

          {projetsAffichés.map((projet) => (
            <div className="col-12 col-sm-6 col-lg-4 projetsListe" key={projet.id}>
              <div>
                <div className="imageWrapper">
                  <span className="petitesIcones">
                    {projet.technos.map((techno, index) => (
                      <TechnoIcon key={index} techno={techno} />
                    ))}
                  </span>
                  <img
                    className="imageProjet"
                    src={require(`./../assets/${projet.images[0]}`)}
                    alt={projet.title || projet.titre}
                  />
                  <div
                    className="OverlayHover"
                    onClick={() => {
                      history.push(`/projet/${projet.id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></div>
                </div>
                <h3>{projet.title || projet.titre}</h3>
                <h4 className="coursEtDate petit">{projet.cours || projet.cours}</h4>
                <p>{projet.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListeDeProjets;
